import { atom } from 'recoil'

const key = '@app/pending-task-count'

const pendingTaskCountAtom = atom<number>({
  key,
  default: 0,
})

export { pendingTaskCountAtom }
